import React from 'react'

import { Link } from 'react-router-dom'
import { Centered, Content } from '@shared/components/Layout'
import { FiArrowLeft } from 'react-icons/fi'

import { Info, Title } from './styles'

const NotFound = () => {
  return (
    <Centered>
      <Content>
        <Title>
          Ops! Não encontramos esta página.
        </Title>
        <Info >
          <Link className="goback" to="/">
            <Centered>
              <FiArrowLeft style={{ marginRight: '4px' }}/>
              Voltar para o início
            </Centered>
          </Link>
        </Info>
      </Content>
    </Centered>
  )
}

export default NotFound
